import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, initializeFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

// Configuration Firebase utilisant les variables d'environnement
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Validation de la configuration
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  throw new Error('Configuration Firebase manquante. Vérifiez vos variables d\'environnement.');
}



// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services avec gestion d'erreur
export const auth = getAuth(app);
// Utiliser initializeFirestore pour optimiser le transport réseau et éviter les retards (~30s)
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  ignoreUndefinedProperties: true
});
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Configuration Firestore pour une meilleure gestion des erreurs
try {
  // Activer la persistance hors ligne si possible
  if (typeof window !== 'undefined') {

    
    // Initialiser le service de santé Firestore
    import('./firestoreHealthService').then(({ default: healthService }) => {
      healthService.checkFirestoreHealth();
    });
  }
} catch (error) {
  // Configuration Firestore échouée - continuer sans persistance
}



export default app;